import { render, staticRenderFns } from "./signup.vue?vue&type=template&id=cacbc2c4"
import script from "./signup.vue?vue&type=script&lang=js"
export * from "./signup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Field: require('/vercel/path0/components/ui/field.vue').default,ConsentCheckbox: require('/vercel/path0/components/ui/consentCheckbox.vue').default,PrimaryButton: require('/vercel/path0/components/ui/primaryButton.vue').default})
